import { useMutation } from 'react-query'
import { api } from '../../../api'
import { type ProjectPersistence } from '../../../../types/persistence/project-persistence'

const editProject = async (id: number, data: ProjectPersistence) => {
  const asset = data?.assetIds?.map((item) => {
    return Number(item.id)
  })

  const analyst = data?.analystIds?.map((item) => {
    return Number(item.id)
  })

  const dataFormated = { ...data, assetIds: asset, analystIds: analyst }

  const response = await api.put(`/projects/${id}`, dataFormated)
  return response.data
}

export const useProjectEditMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: ProjectPersistence }) {
      return editProject(id, data)
    }
  })
}
